import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=78c2139c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c2139c')) {
      api.createRecord('78c2139c', component.options)
    } else {
      api.reload('78c2139c', component.options)
    }
    module.hot.accept("./Close.vue?vue&type=template&id=78c2139c", function () {
      api.rerender('78c2139c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Register/Close.vue"
export default component.exports